import addComponentLoader, { importWithRetry } from '@/utils/component-loader'
import { defineAsyncComponent } from 'vue'

const componentMapping =  {
  eventRsvp: defineAsyncComponent(() => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "event-rsvp-root" */ './root')))
}

addComponentLoader(componentMapping, {}, () => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "event-rsvp-root-store-getter" */ './store')))
